var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "#AF2732"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5996 21.4001C12.5996 21.9524 13.0473 22.4001 13.5996 22.4001H14.3996C14.9519 22.4001 15.3996 21.9524 15.3996 21.4001V16.4001C15.3996 15.8478 15.8473 15.4001 16.3996 15.4001H21.3996C21.9519 15.4001 22.3996 14.9524 22.3996 14.4001V13.6001C22.3996 13.0478 21.9519 12.6001 21.3996 12.6001H16.3996C15.8473 12.6001 15.3996 12.1524 15.3996 11.6001V6.6001C15.3996 6.04781 14.9519 5.6001 14.3996 5.6001L13.5996 5.6001C13.0473 5.6001 12.5996 6.04781 12.5996 6.6001V11.6001C12.5996 12.1524 12.1519 12.6001 11.5996 12.6001H6.59961C6.04732 12.6001 5.59961 13.0478 5.59961 13.6001V14.4001C5.59961 14.9524 6.04732 15.4001 6.59961 15.4001H11.5996C12.1519 15.4001 12.5996 15.8478 12.5996 16.4001V21.4001Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.594070aceb558e4a8646c1afd0b55f2e.svg";
export { ForwardRef as ReactComponent };